import Button from '../../components/shared/button';
import { getDocGARight } from '../../project/helpers';
import { type SatcFamillesModel } from '../../store/satc/satcModels';
import { copyToClipboard } from '../../utils/helpers';
import useTranslation from '../../utils/hooks/useTranslation';

const TabProcDepannage: React.FC<{ data: SatcFamillesModel }> = ({ data }) => {
  const { proc_depannage } = data;
  const { t } = useTranslation();

  return (
    <group
      data-space="1"
      data-space-vertical="20"
      data-gap="20"
      width="initial"
      direction="row"
    >
      <group
        direction="row"
        data-gap="10"
        data-type="grid"
        data-grid-size="330"
        data-align="start"
      >
        <div className="table_view">
          <table>
            <thead>
              <tr>
                <th>{t("satc.detail.tabs.videoTutos.first")}</th>
                <th>{t("satc.detail.tabs.videoTutos.second")}</th>
                <th>{t("satc.detail.tabs.videoTutos.second")}</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(proc_depannage).map((key: any) => {
                const item = proc_depannage[key];
                let tags = getDocGARight(item.tags);
                return (
                  <tr key={item.uuid}>
                    <td>
                      <wrap>
                        <a
                          data-type="link"
                          href={item.download}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.title}
                        </a>
                      </wrap>
                    </td>
                    <td>
                      <wrap>
                        <text data-wrap="wrap">{tags.join(", ")}</text>
                      </wrap>
                    </td>
                    <td>
                      <Button
                        extra
                        onClick={() => copyToClipboard(t, item.download)}
                      >
                        <icon>content_copy</icon>
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </group>
    </group>
  );
};

export default TabProcDepannage;
